export const ADD_USER_PROFILE_TO_STORE = "addUserProfileToStore";
export const SET_AZURE_HEADER = "setAzureHeader";
